<template>
    <van-nav-bar :title="$t('邮箱验证')" left-arrow @click-left="router.back()" />
    <div class="tips">{{ $t("温馨提示：如果您没有绑定过邮箱，请联系客服找回密码") }}</div>

    <van-form @submit="onSubmit">
        <van-cell-group style="margin-top: 15px;" inset>
            <van-field v-model="email" :placeholder="$t('请输入邮箱')"></van-field>

            <div class="get-code-class">
                <van-field v-model="code" :placeholder="$t('请输入验证码')"></van-field>
                <div v-if="codeShow" @click="getCode" class="code_btn">{{
                    $t("获取验证码") }}</div>
                <div v-else class="code_btn">{{ count }}s</div>
            </div>

        </van-cell-group>
        <div style="margin: 16px;">
            <van-button round block type="primary" native-type="submit"
                :disabled="(email.length == 0 || code.length == 0)">
                {{ $t("me.ok") }}
            </van-button>
        </div>
    </van-form>
</template>

<style scoped>
.tips {
    color: #898989;
    font-size: 12px;
    margin-left: 26px;
    margin-top: 20px;
}

.get-code-class {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.code_btn {
    color: #4A88FC;
    /* width: 80px; */
    white-space: nowrap;
    height: 20px;
    margin-right: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
}

:deep(.van-field) {
    padding: 15px 18px;
}
</style>


<script setup>
import { ref, onMounted } from "vue"
import { useRouter } from "vue-router";
import { usePiniaState } from "@/store/userPinia";
import { Toast } from "vant"
import { useI18n } from "vue-i18n";
import { getValidByEmail } from "@/api/im/index"

const { t } = useI18n();
const piniaStore = usePiniaState();
const { toLogin } = piniaStore;

const router = useRouter();
const count = ref(60);
const email = ref('');
const code = ref('');
const codeShow = ref(true);
let time = null;
const TIME_COUNT = 30; //倒计时30秒

onMounted(() => {
    
    toLogin();
});

const getCode = async () => {
    
    if (email.value.length == 0) {
        return;
    }
    if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email.value)) {
        Toast.fail(t('邮箱格式不正确'))
        return
    }
    const res = await getValidByEmail({
        mtype: "1",
        email: email.value
    });

    if (res.ret == 0) {
        if (!time) {
            count.value = TIME_COUNT;
            codeShow.value = false;
            time = setInterval(() => {
                if (count.value > 0 && count.value <= TIME_COUNT) {
                    count.value--;
                } else {
                    codeShow.value = true;
                    clearInterval(time);
                    time = null;
                }
            }, 1000);
        }
    } else {
        Toast.fail(res.msg);
    }
}

const onSubmit = () => {
    router.push({
        path: "/Changepwd",
        query: { 
            jumpType: "1",
            verifycode: code.value,
            email: email.value 
        }
    })
};

</script>